title: Behandeling|Behandelingen
stepperHeadings:
  selectTreatment: Behandeling
  chooseUser: Medewerker
  chooseDateAndTime: Datum & tijd
  agreements: Informatie
  selectCustomer: Gegevens
  confirmation: Bevestiging
fields:
  customer: Selecteer een klant of vul nieuwe gegevens in
  firstName: Voornaam
  insertions: Tussenvoegsel
  lastName: Achternaam
  email: E-mail
  phoneNumber: Telefoonnummer
labels:
  kindPreference: Geen voorkeur
  availableSeats: Nog {count} plek vrij|Nog {count} plekken vrij
  pricePerPerson: Prijs per persoon
  backTo: terug naar {name}
  selectDate: Selecteer datum
  availableTimes: Beschikbare tijden
  agreements: Belangrijke informatie
  chooseUser: Kies medewerker
  chooseAppointment: Selecteer behandeling
  fillInYourInformation: Vul je gegevens in
  chooseDateAndTime: Kies datum & tijd
  moveToInformation: Doorgaan naar gegevens
  acceptAgreements: Bevestig de informatie hierboven om door te gaan
  confirmAppointment: Bevestig afspraak
  existingCustomer: Bestaande klant?
  customer: Naam
  customerName: Naam
  customerEmail: Email
  treatment: Behandeling
  user: Medewerker
  date: Datum
  time: Tijd
  price: Prijs
  comment: Opmerkingen
  total: Totaal
  appointmentConfirmed: Behandeling bevestigd!
  createNewAppointment: Nieuwe afspraak maken
  showInCalendar: Toon in agenda
messages:
  checkAllAgreements: Vink alle checkboxes aan om door te gaan
  appointmentCreated: Je afspraak is succesvol geboekt. Je ontvangt een bevestiging per email.
  errorCreatingNewAppointment: Er is een fout opgetreden bij het aanmaken van een nieuwe boeking.
  clickToExpand: Klap open om te lezen en akkoord te gaan
  preparationAgreement:
    title: Kom goed voorbereid
    confirmText: Ik heb de voorbereidingsinstructies gelezen en zal deze opvolgen
  healthDeclarationAgreement:
    title: Jouw gezondheidsverklaring
    confirmText: Ik bevestig dat ik geen van bovenstaande aandoeningen heb
enums:
  treatmentType:
    Individual: Individueel
    Group: Groep
